import { VisAuthService } from '@vis-auth/react';
import { EveRoutes } from '@ver-uds/e-verify';
import { useEnvironment } from '../context/Environment/EnvironmentContext';

export const GetAuthServiceMFA = (logoutUri?: string) => {
  const { AUTH_URL, LOGIN_DOT_GOV_AUTH_CLIENTID, LOGIN_DOT_GOV_URL } = useEnvironment();

  const authService = new VisAuthService({
    issuer: AUTH_URL,
    clientId: LOGIN_DOT_GOV_AUTH_CLIENTID,
    redirectUri: window.location.origin + EveRoutes.LOGIN,
    tokenStorage: 'cookie',
    errorPath: '/error',
    loginDotGovUrl: LOGIN_DOT_GOV_URL,
    logoutUri: logoutUri ?? window.location.origin + EveRoutes.LOGOUT,
  });

  return authService;
};

export default GetAuthServiceMFA;
